import { useMemo } from 'react'
import { getClientUserId } from '$logic/client-user'
import { useSearchInSubscribers } from '$logic/subscription/react-hook'

export function useMentionUsers(roomId: string, query: string) {
  const { loading, items } = useSearchInSubscribers(roomId, query)

  const users = useMemo(
    () => items.map(item => item.id).filter(id => id !== getClientUserId()),
    [query, items],
  )

  return { loading, users }
}
